import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i4 from '@taiga-ui/cdk';
import { TuiMonth, TUI_FIRST_DAY, TUI_LAST_DAY, tuiDefaultProp, TuiFocusableModule } from '@taiga-ui/cdk';
import * as i1 from '@taiga-ui/core/components/primitive-spin-button';
import { TuiPrimitiveSpinButtonModule } from '@taiga-ui/core/components/primitive-spin-button';
import * as i2 from '@taiga-ui/core/components/link';
import { TuiLinkModule } from '@taiga-ui/core/components/link';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@taiga-ui/core/pipes';
import { TuiMonthPipeModule } from '@taiga-ui/core/pipes';

class TuiPrimitiveYearMonthPaginationComponent {
    constructor() {
        this.value = TuiMonth.currentLocal();
        this.min = TUI_FIRST_DAY;
        this.max = TUI_LAST_DAY;
        this.valueChange = new EventEmitter();
        this.yearClick = new EventEmitter();
    }
    get prevMonthDisabled() {
        return this.value.monthSameOrBefore(this.min);
    }
    get nextMonthDisabled() {
        return this.value.monthSameOrAfter(this.max);
    }
    get oneYear() {
        return this.min.year === this.max.year;
    }
    onYearClick() {
        this.yearClick.next(this.value);
    }
    onPrevMonthClick() {
        this.appendValueWithLimit({ month: -1 });
    }
    onNextMonthClick() {
        this.appendValueWithLimit({ month: 1 });
    }
    appendValueWithLimit(date) {
        const newMonth = this.value.append(date);
        if (this.min.monthSameOrAfter(newMonth)) {
            this.updateValue(this.min);
            return;
        }
        if (this.max.monthSameOrBefore(newMonth)) {
            this.updateValue(this.max);
            return;
        }
        this.updateValue(newMonth);
    }
    updateValue(value) {
        if (this.value.monthSame(value)) {
            return;
        }
        this.value = value;
        this.valueChange.emit(value);
    }
}
TuiPrimitiveYearMonthPaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPrimitiveYearMonthPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TuiPrimitiveYearMonthPaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiPrimitiveYearMonthPaginationComponent, selector: "tui-primitive-year-month-pagination", inputs: { value: "value", min: "min", max: "max" }, outputs: { valueChange: "valueChange", yearClick: "yearClick" }, ngImport: i0, template: "<tui-primitive-spin-button\n    [focusable]=\"false\"\n    [leftDisabled]=\"prevMonthDisabled\"\n    [rightDisabled]=\"nextMonthDisabled\"\n    (leftClick)=\"onPrevMonthClick()\"\n    (rightClick)=\"onNextMonthClick()\"\n>\n    {{ value | tuiMonth | async }}\n    <ng-container *ngIf=\"oneYear; else button\">\n        {{ value.formattedYear }}\n    </ng-container>\n    <ng-template #button>\n        <button\n            id=\"year-btn\"\n            automation-id=\"tui-primitive-year-month-pagination__year-button\"\n            tuiLink\n            type=\"button\"\n            [tuiFocusable]=\"false\"\n            (click)=\"onYearClick()\"\n        >\n            {{ value.formattedYear }}\n        </button>\n    </ng-template>\n</tui-primitive-spin-button>\n", styles: [":host{display:block}\n"], components: [{ type: i1.TuiPrimitiveSpinButtonComponent, selector: "tui-primitive-spin-button", inputs: ["disabled", "mode", "leftDisabled", "rightDisabled"], outputs: ["leftClick", "rightClick"] }, { type: i2.TuiLinkComponent, selector: "a[tuiLink], button[tuiLink]", inputs: ["pseudo", "icon", "iconAlign", "iconRotated", "mode"], exportAs: ["tuiLink"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.TuiFocusableDirective, selector: "[tuiFocusable]", inputs: ["tuiFocusable"] }], pipes: { "async": i3.AsyncPipe, "tuiMonth": i5.TuiMonthPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    tuiDefaultProp()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "value", void 0);
__decorate([
    tuiDefaultProp()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "min", void 0);
__decorate([
    tuiDefaultProp()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "max", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPrimitiveYearMonthPaginationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-primitive-year-month-pagination',
                    templateUrl: './primitive-year-month-pagination.template.html',
                    styleUrls: ['./primitive-year-month-pagination.style.less'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { value: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], yearClick: [{
                type: Output
            }] } });

class TuiPrimitiveYearMonthPaginationModule {
}
TuiPrimitiveYearMonthPaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPrimitiveYearMonthPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiPrimitiveYearMonthPaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPrimitiveYearMonthPaginationModule, declarations: [TuiPrimitiveYearMonthPaginationComponent], imports: [CommonModule,
        TuiFocusableModule,
        TuiPrimitiveSpinButtonModule,
        TuiLinkModule,
        TuiMonthPipeModule], exports: [TuiPrimitiveYearMonthPaginationComponent] });
TuiPrimitiveYearMonthPaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPrimitiveYearMonthPaginationModule, imports: [[
            CommonModule,
            TuiFocusableModule,
            TuiPrimitiveSpinButtonModule,
            TuiLinkModule,
            TuiMonthPipeModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPrimitiveYearMonthPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TuiFocusableModule,
                        TuiPrimitiveSpinButtonModule,
                        TuiLinkModule,
                        TuiMonthPipeModule,
                    ],
                    declarations: [TuiPrimitiveYearMonthPaginationComponent],
                    exports: [TuiPrimitiveYearMonthPaginationComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPrimitiveYearMonthPaginationComponent, TuiPrimitiveYearMonthPaginationModule };
